
<template lang="pug">
.venues.router-view-container.d-none
</template>
<script>
export default {
  name: 'Home',
  created: function () {
    //旧ページへのハッシュ付きリンクを処理
    switch (window.location.hash.toLowerCase()) {
      case '#tab01':
        this.$router.replace({ name: 'Venues', params: {areas: 'hokkaido,aomori,iwate,miyagi,akita,yamagata,fukushima'}})
        break
      case '#tab02':
        this.$router.replace({ name: 'Venues', params: {areas: 'saitama,chiba,tokyo,kanagawa'}})
        break
      case '#tab03':
        this.$router.replace({ name: 'Venues', params: {areas: 'ibaraki,tochigi,gunma,saitama,niigata,yamanashi,nagano'}})
        break
      case '#tab04':
        this.$router.replace({ name: 'Venues', params: {areas: 'toyama,ishikawa,fukui,gifu,shizuoka,aichi,mie'}})
        break
      case '#tab05':
        this.$router.replace({ name: 'Venues', params: {areas: 'shiga,kyoto,osaka,hyogo,nara,wakayama'}})
        break
      case '#tab06':
        this.$router.replace({ name: 'Venues', params: {areas: 'tottori,shimane,okayama,hiroshima,yamaguchi,tokushima,kagawa,ehime,kochi'}})
        break
      case '#tab07':
        this.$router.replace({ name: 'Venues', params: {areas: 'fukuoka,saga,nagasaki,kumamoto,oita,miyazaki,kagoshima,okinawa'}})
        break
    }
  }
}
</script>
